import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

// Custom styled Swal
const customSwal = Swal.mixin({
  customClass: {
    confirmButton: 'px-6 py-2.5 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white font-medium rounded-lg shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] mx-2',
    cancelButton: 'px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors mx-2',
    popup: 'rounded-2xl shadow-2xl',
    title: 'text-2xl font-bold text-gray-800',
    htmlContainer: 'text-gray-600',
  },
  buttonsStyling: false,
  showClass: {
    popup: 'animate__animated animate__fadeInDown animate__faster'
  },
  hideClass: {
    popup: 'animate__animated animate__fadeOutUp animate__faster'
  }
});

// Success alert - Using toast
export const showSuccess = (message, title = 'Başarılı!') => {
  toast.success(message, {
    duration: 3000,
  });
};

// Error alert - Using toast
export const showError = (message, title = 'Hata!') => {
  toast.error(message, {
    duration: 4000,
  });
};

// Warning alert - Using toast
export const showWarning = (message, title = 'Uyarı!') => {
  toast(message, {
    icon: '⚠️',
    duration: 3000,
  });
};

// Info alert - Using toast
export const showInfo = (message, title = 'Bilgi') => {
  toast(message, {
    icon: 'ℹ️',
    duration: 3000,
  });
};

// Confirm dialog
export const showConfirm = (message, title = 'Emin misiniz?', confirmText = 'Evet', cancelText = 'Hayır') => {
  return customSwal.fire({
    icon: 'question',
    title: title,
    text: message,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
  });
};

// Delete confirmation
export const showDeleteConfirm = (itemName = 'Bu öğeyi') => {
  return customSwal.fire({
    icon: 'warning',
    title: 'Silmek istediğinizden emin misiniz?',
    html: `<p class="text-gray-600">${itemName} <strong>kalıcı olarak silinecektir.</strong></p><p class="text-sm text-gray-500 mt-2">Bu işlem geri alınamaz!</p>`,
    showCancelButton: true,
    confirmButtonText: 'Evet, Sil',
    cancelButtonText: 'İptal',
    reverseButtons: true,
    customClass: {
      confirmButton: 'px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium rounded-lg shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] mx-2',
      cancelButton: 'px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors mx-2',
    },
  });
};

// Loading alert
export const showLoading = (message = 'Yükleniyor...') => {
  return Swal.fire({
    title: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

// Close loading
export const closeLoading = () => {
  Swal.close();
};

export default customSwal;
